export const getLanguageCodeForTranslation = (culture: string): string => {
  const languageMap: { [key: string]: string } = {
    "en-US": "en-US",
    "zh-CN": "zh-CN",
    "th-TH": "th",
    "vi-VN": "vi-VN",
    "hi-IN": "HI",
    "es-ES": "es-ES",
    "en-PH": "tl-PH",
    "zh-TW": "TW",
    "ko-KR": "KR",
    "ja-JP": "ja-JP",
    "ar-AE": "ar-AE",
    "id-IN": "id-IN",
    "id-ID": "id-IN",
    "ur-PK": "ur-PK",
  };
  return languageMap[culture] || "en-US";
};

export const getLanguageCodeForAuthPages = (culture: string): string => {
  const languageMap: { [key: string]: string } = {
    "en-US": "en",
    en: "en",
    "zh-CN": "zh",
    zh: "zh",
    "th-TH": "th",
    th: "th",
    "vi-VN": "vi",
    vi: "vi",
    "hi-IN": "HI",
    hi: "HI",
    HI: "HI",
    "es-ES": "es",
    es: "es",
    "en-PH": "tl",
    "tl-PH": "tl",
    fil: "tl",
    tl: "tl",
    ph: "tl",
    "zh-TW": "TW",
    TW: "TW",
    "ja-JP": "jp",
    jp: "jp",
    ja: "jp",
    "ko-KR": "KR",
    KR: "KR",
    ko: "KR",
    "id-IN": "id",
    "id-ID": "id",
    id: "id",
    "ur-PK": "ur",
    ur: "ur",
    "ar-AE": "ar",
    ar: "ar",
  };
  return languageMap[culture] || "en";
};
